import { all } from 'redux-saga/effects';

function* watchUpdateUser() {
    yield localStorage.getItem('user');
}

export default function* userSaga() {
    yield all([watchUpdateUser()]);
}
